import Vue from 'vue';

Vue.component('model-specs-component', {
    props: {
        allSpecs: {
            type: Object,
            required: true,
        },
        areSpecsVisible: {
            type: Boolean,
            required: true,
        },
        modelName: {
            type: String,
            default: 'MG Car',
        },
        isDarkMode: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            specsSelectedModelName: '',
            selectedSpecs: null,

            selectedConfigurationTitle: null,
            selectedConfiguration: null,
            selectedSpecsModelType: null,
            selectedSpecsModelSubline: null,
            selectedSpecsModelSublineAsset: null,
            selectedSpecsDisclaimer: null,
        };
    },

    mounted() {
        EventBus.$on('openSpecs', () => {
            this.selectedSpecs = this.allSpecs;
            this.selectedConfigurationTitle = this.allSpecs.values[0].title;
            this.selectedConfiguration = this.getSelectedConfiguration(
                this.allSpecs.values[0].title,
            );
            this.specsSelectedModelName = this.modelName;
            this.selectedSpecsModelType = '';
            this.selectedSpecsModelSubline = '';
            this.selectedSpecsModelSublineAsset = null;

            document.body.style.overflow = 'hidden';
        });
    },

    watch: {
        areSpecsVisible(newValue) {
            window.document.body.style.overflowY = newValue ? 'hidden' : 'auto';
            if (!newValue) return;
        },
    },

    methods: {
        getSelectedConfiguration(configuration) {
            const selectedConfiguration = this.allSpecs.values.find(
                (configValue) => configValue.title === configuration,
            );
            if (!selectedConfiguration) return null;
            this.selectedSpecsDisclaimer = selectedConfiguration.disclaimer;
            const { editions, values } = selectedConfiguration;

            const filteredEditions = editions.filter(
                (edition) => !edition.isDisabled,
            );

            if ('colorTitle' in values[0]) {
                const tableTitle = [
                    { title: values[0].title },
                    ...filteredEditions.map((edition) => ({
                        title: edition.name || '',
                        subtitle: edition.subtitle,
                    })),
                ];
                const parsedColorValues = values.map((value) => [
                    {
                        colorTitle: value?.colorTitle,
                        colorImage: value.image?.url,
                    },
                    ...this.parseValues(value.values[0]),
                ]);
                return [{ tableTitle, tableData: parsedColorValues }];
            }
            const tableData = values.map((value) => ({
                tableTitle: [
                    { title: value.title },
                    ...filteredEditions.map((edition) => ({
                        title: edition.name,
                        subtitle: edition.subtitle,
                    })),
                ],
                tableData: value.values,
            }));

            return tableData;
        },

        parseValues(values) {
            if (Array.isArray(values)) return values;
            if (typeof values === 'object') {
                return Object.values(values);
            }
            return [];
        },

        closeSpecs() {
            EventBus.$emit('closeSpecs');
            document.body.style.overflow = 'auto';
        },

        selectConfiguration(configuration) {
            this.selectedConfigurationTitle = configuration;
            this.selectedConfiguration =
                this.getSelectedConfiguration(configuration);
        },

        isSelectedConfiguration(configuration) {
            return this.selectedConfigurationTitle === configuration
                ? 'new-model-specs__sidebar__selector--active'
                : '';
        },

        isSelectedConfiguration(configuration) {
            return this.selectedConfigurationTitle === configuration
                ? this.isDarkMode
                    ? 'new-model-specs__sidebar__selector--light-active'
                    : 'new-model-specs__sidebar__selector--active'
                : '';
        },

        checkItemsLength(selectedConfiguration) {
            return selectedConfiguration[0].tableTitle.length <= 3
                ? ''
                : 'new-model-specs__table-container--horizontal-scroll';
        },
    },
});
